// Formatter & Label-Helfer für die Gutachten-Dokumentation (A4-Ansicht).
// Übersetzung der doc_type-Codes zu Anzeige-Labels in der Bundle-Sidebar.
// Backend speichert kurze Codes (dat_calculation, cession, ...), wir zeigen
// dem User aber sprechende deutsche Bezeichnungen.
export const DOC_TYPE_LABELS = {
  dat_calculation: "DAT-Kalkulation",
  cession: "Abtretungserklärung",
  abtretung: "Abtretungserklärung",
  photos: "Lichtbilder",
  fahrzeugschein: "Fahrzeugschein",
  unfallbericht: "Unfallbericht",
  invoice: "Rechnung",
  gutachten_bundle: "Gebündelt",
  other: "Anhang",
};

export const LOGO_URL = "/easy-gutachter-logo.png";

// Resolve user's letterhead logo to an authenticated URL. We append the
// access_token as `?auth=` query-param (matches /api/files/download/{path}
// endpoint which accepts cookie, Bearer header OR ?auth=<jwt>).
export function letterheadLogoUrl(path, backendUrl, token) {
  if (!path) return null;
  const base = backendUrl || process.env.REACT_APP_BACKEND_URL || "";
  const t = token ? `?auth=${encodeURIComponent(token)}` : "";
  return `${base}/api/files/download/${encodeURI(path)}${t}`;
}

// Same URL builder for case photos (storage_path → authenticated image URL)
export function photoUrl(path, token) {
  if (!path) return null;
  const base = process.env.REACT_APP_BACKEND_URL || "";
  const t = token ? `?auth=${encodeURIComponent(token)}` : "";
  return `${base}/api/files/download/${encodeURI(path)}${t}`;
}

// Human-readable label for photo category (DB stores enum keys like "vorne_links")
export const PHOTO_CATEGORY_LABELS = {
  vorne_links: "Front links",
  vorne_rechts: "Front rechts",
  hinten_links: "Heck links",
  hinten_rechts: "Heck rechts",
  front: "Frontansicht",
  heck: "Heckansicht",
  links: "Linke Seite",
  rechts: "Rechte Seite",
  tacho: "Tachostand",
  vin: "Fahrzeug-Identifizierungsnummer",
  hsn_tsn: "HSN / TSN",
  innenraum: "Innenraum",
  motor: "Motorraum",
  schaden: "Schadenbereich",
  detail: "Detailaufnahme",
  uebersicht: "Übersicht",
};
export const photoLabel = (p, i) => p?.caption?.trim() || PHOTO_CATEGORY_LABELS[p?.category] || p?.category || `Lichtbild ${i + 1}`;

// ---------- Formatter ------------------------------------------------------
export const fmtEUR = (v, suffix = " EUR") => {
  const n = Number(v);
  if (!Number.isFinite(n)) return "—";
  return n.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + suffix;
};
export const fmtDateLong = (iso) => {
  if (!iso) return "—";
  try {
    // Handle Date objects, MongoDB BSON {$date:"..."}, numbers (epoch ms), and ISO strings safely.
    let parseInput = iso;
    if (typeof iso === "object") {
      if (iso instanceof Date) parseInput = iso.toISOString();
      else if (iso && typeof iso.$date === "string") parseInput = iso.$date;
      else return "—"; // unknown object shape — never render raw object
    }
    if (typeof parseInput === "string" && parseInput.length === 10) parseInput = parseInput + "T00:00:00";
    const d = new Date(parseInput);
    if (isNaN(d.getTime())) return typeof parseInput === "string" ? parseInput : "—";
    return d.toLocaleDateString("de-DE", { day: "numeric", month: "long", year: "numeric" });
  } catch { return "—"; }
};
export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso.length === 10 ? iso + "T00:00:00" : iso);
    if (isNaN(d.getTime())) return iso;
    return d.toLocaleDateString("de-DE", { day: "numeric", month: "long", year: "numeric" }) + " " +
      d.toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" }) + " Uhr";
  } catch { return iso; }
};
export const fmtKM = (n) => {
  const num = Number(n);
  if (!Number.isFinite(num)) return "—";
  return num.toLocaleString("de-DE") + " km";
};
export const dash = (v) => (v === null || v === undefined || v === "" ? "—" : v);
